import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const errorStatusCodeSlice = createSlice({
    name: "errorStatusCode",
    initialState: { value: false },
    reducers: {
        updateErrorStatusCode: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

export const { updateErrorStatusCode } = errorStatusCodeSlice.actions;
export const errorStatusCodeReducer = errorStatusCodeSlice.reducer;
